'use strict';

// Constructor
var Card = function() {

	//assign total value to heading element
    $("[data-id='Reminder'] .badge").html($('#ReminderCount').val());
    $("[data-id='Circulars'] .badge").html($('#CircularCount').val());
    $("[data-id='Newsletter'] .badge").html($('#NewsLetterCount').val());
    $("[data-id='PositionsVacant'] .badge").html($('#PositionVacantCount').val());
    $("[data-id='ProfessionalLearning'] .badge").html($('#ProfessionalLearningCount').val());
    $("[data-id='Others'] .badge").html($('#OthersCount').val());

	//Card expand button event
	$('.expand').on('click', function(e){
		e.preventDefault();
		if($(this).parents('.card').hasClass('hide-me')){
			$(this).parents('.card').removeClass('hide-me');
            $(this).removeClass('icomoon-expand').addClass('icomoon-collapse');
		}
		else{
			$(this).parents('.card').addClass('hide-me');
            $(this).removeClass('icomoon-collapse').addClass('icomoon-expand');
		}
	});

    //Card tab navigation
        $('.card_tab_nav li').on('click', function(e){
            e.preventDefault();

            var currentCard = $(this).parents('.card');
            var navId = $(this).find("a").attr("data-id");
            var selector = "[data-id=\"" + navId + "_Container" + "\"]";
            $('.tab_nav_body', currentCard).removeClass('active');
            $(selector).addClass('active');

            if($(this).hasClass('active')){
                $(this).parents('ul').toggleClass('select');
            }
            else{
                $('.card_tab_nav li', currentCard).removeClass('active');
                $(this).parents('ul').toggleClass('select');
                $(this).addClass('active');
            }
        });
}

module.exports = Card;
